import React from 'react';
import {
  FDStack,
  FDPaper,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { TaxDiagnosticWrapperLayout } from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxDiagnosticWrapperLayout';
import { SmallNumberStepper } from 'Packages/FacetDesign/Components/Experimental/SmallNumberStepper';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LightPaper } from 'Views/Page/Content/Templates/TaxDiagnosticQuestionStepTemplate/LightPaper';
import { dataAttrs } from 'Helpers/Testing';


const Layout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <TaxDiagnosticWrapperLayout>
      <FDStack direction={'column'} alignItems={'stretch'} spacing={3} maxWidth={'600px'}>
        <FDPaper appearance={'elevated'} overflow={'hidden'}>
          <FDStack direction={'column'} padding={3} spacing={3}>
            <SmallNumberStepper
              labelPrefix="Opportunity"
              numSteps={parseInt(resource.attr('numRelevantStepsInModule'), 10)}
              numCompleted={parseInt(resource.attr('currentStepIndex'), 10)}
            />
            <MetaControlField attr="header" />
            <MetaControlField attr={'title'} {...dataAttrs('question-step-title')} />
            <LightPaper padding={2}>
              <MetaControlField attr="description" />
            </LightPaper>
          </FDStack>
        </FDPaper>
        <FDPaper appearance={'elevated'} padding={3}>
          <MetaControlField attr="question" {...dataAttrs('question-input')} />
        </FDPaper>
      </FDStack>
    </TaxDiagnosticWrapperLayout>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
